import React, { useRef, useEffect } from 'react';

const PurpleMatrix = () => {
  const canvasRef = useRef(null);
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set canvas size to match window
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    // Characters to display (story-related)
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789$&+,:;=?@#|{}[]<>~';
    
    // Font size and column information
    const fontSize = 14;
    // Reduce columns by 20% to have fewer characters
    const columns = Math.floor((canvas.width / fontSize) * 0.8);
    
    // Array to track Y position of each column
    const drops = [];
    for (let i = 0; i < columns; i++) {
      drops[i] = Math.random() * -canvas.height;
    }
    
    // Function to draw the matrix effect
    const draw = () => {
      // Semi-transparent background to create fade effect
      // Increased opacity from 0.1 to 0.25 to make trails fade much faster
      ctx.fillStyle = 'rgba(10, 10, 14, 0.18)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // Draw characters
      for (let i = 0; i < drops.length; i++) {
        // Get random character
        const text = characters.charAt(Math.floor(Math.random() * characters.length));
        
        // Enhanced color variations with wider range
        const hueBase = 270; // Base purple hue
        const hueRange = 60; // Wider range for more color variation
        const hue = hueBase + Math.random() * hueRange - (hueRange / 2); // From 240 to 300 (blue to violet/magenta)
        const saturation = 50 + Math.random() * 50; // From 50% to 100% saturation
        const lightness = 40 + Math.random() * 50; // From 40% to 90% lightness for more brightness variation
        ctx.fillStyle = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
        
        // Set font size with slight variation
        ctx.font = `${fontSize + Math.random() * 2}px monospace`;
        
        // Draw the character
        ctx.fillText(text, i * fontSize, drops[i] * 1);
        
        // Add some random bright characters for emphasis - increased brightness and frequency
        if (Math.random() > 0.95) {
          // Create occasionally very bright characters that stand out
          ctx.fillStyle = `hsl(${hue}, 80%, 90%)`; // Brighter version
          ctx.fillText(text, i * fontSize, drops[i] * 1);
        }
        
        // Reset position when it goes out of screen + random factor
        if (drops[i] * 1 > canvas.height && Math.random() > 0.99) {
          drops[i] = 0;
        }
        
        // Move the drop down (variable speed)
        drops[i] += Math.random() * 2 + 1;
      }
    };
    
    // Animation loop
    const interval = setInterval(draw, 40);
    
    // Handle window resize
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <canvas 
      ref={canvasRef} 
      className="purple-matrix-canvas"
    />
  );
};

export default PurpleMatrix;
